import styled from '@emotion/styled'
import { FunctionComponent, ReactNode } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Icon, IconName } from '~/components/Icon'
import { TrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { WithClassName } from '~/types/utils'

const Card = styled.div<{ isSelected: boolean }>`
  background-color: ${Colors.White};
  border: 1px solid ${({ isSelected }) => (isSelected ? Colors.King : Colors.Platinum)};

  border-radius: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 70px;
  cursor: pointer;
  --format-icon-color: ${({ isSelected }) => (isSelected ? Colors.Turquoise : Colors.Sora)};

  :hover {
    border: 1px solid ${({ isSelected }) => (isSelected ? Colors.King : Colors.Silver)};
    --format-icon-color: ${Colors.Turquoise};
  }
`

const Content = styled.div<{ withHelp: boolean }>`
  padding: 12px ${({ withHelp }) => (withHelp ? '0px' : '12px')} 12px 12px;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-grow: 2;
`

const Label = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`
const Title = styled.div`
  ${Fonts.P1};
  ${Fonts.colors.Jet};
  font-weight: 700;
`

const Subtitle = styled.div`
  ${Fonts.P3};
`

const Help = styled.div`
  align-self: flex-start;
  padding: 8px 8px 0 0;
`

export type SelectorOptionCardProps = WithClassName & {
  iconName: IconName
  title: string
  subtitle: ReactNode
  openHelpClick?: () => void
  isSelected: boolean
  onClick: React.MouseEventHandler<HTMLDivElement>
  trackingLabel: TrackingLabel
}

const BaseSelectorOptionCard: FunctionComponent<SelectorOptionCardProps> = ({ className, iconName, title, subtitle, openHelpClick, isSelected, onClick, trackingLabel }) => {
  return (
    <Card className={className} isSelected={isSelected} onClick={onClick} data-tracking={trackingLabel}>
      <Content withHelp={!!openHelpClick}>
        <Icon name={iconName} height={'36px'} width={'36px'} fill={Colors.Rose} />
        <Label>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Label>
      </Content>
      {openHelpClick && (
        <Help
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()
            event.nativeEvent.stopImmediatePropagation()
            openHelpClick()
          }}
        >
          <Icon name={'help'} width={'18px'} height={'18px'} fill={Colors.King} />
        </Help>
      )}
    </Card>
  )
}

export const SelectorOptionCard = styled(BaseSelectorOptionCard)``
